import { RootState, StoreConstants } from '@/types';
import { NavigationState } from '@/types/store/navigation';
import { ActionTree } from 'vuex';

export const actions: ActionTree<NavigationState, RootState> = {
  [StoreConstants.Navigation.Actions.SetDocumentViewBackRoute]({ commit }, { route, label, params }) {
    commit(StoreConstants.Navigation.Mutations.SetDocumentViewBackRoute, { route, label, params });
  },
  [StoreConstants.Navigation.Actions.ClearDocumentViewBackRoute]({ commit }) {
    commit(StoreConstants.Navigation.Mutations.ClearDocumentViewBackRoute);
  }
};
